import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild,Renderer2, AfterViewInit, ViewChildren, QueryList, ViewEncapsulation, inject, DestroyRef, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {ModalComponent} from '@appkit4/angular-components/modal';
import { SummaryDiagnosticService } from '../../summary-diagnostic.service';
import { GtwElementsBaseUrlsModel } from 'projects/gtw-elements/src/app/shared/_models/gtw-elements-base-urls.model';
import * as _ from 'lodash-es';
import { DropdownComponent } from '@appkit4/angular-components/dropdown';
import { DashboardFilterService } from '../../../dashboard-filter/dashboard-filter.service';


import { safeJsonInput } from '../../../../shared/_utils/safe-json-input';
@Component({
    selector: 'gtw-detail-diag-view',
    templateUrl: './detail-diag-view.component.html',
    styleUrls: ['./detail-diag-view.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class DetailDiagViewComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  @ViewChild('baseModalLargest', { static: false }) baseModalLargest!: ModalComponent;
  @ViewChild('viewHeight') modalContentHeight!: ElementRef;

  @Output() afterModalClosed: EventEmitter<null> = new EventEmitter<null>();
  @ViewChildren('mutlSelect') mutlSelect!: QueryList<DropdownComponent>;

   @Output() loadDrillDownScreen = new EventEmitter<any>();


  //baseURLs: GtwElementsBaseUrlsModel ={'admin':'','api':'/gtw',"custom":'','efile':'','pdfEngine':'','bulkPdfEngine':''};
  gridLoading = false;
  headerMap:any;
  selectedFilterParams :any;
  visibleColumnCount = 1;

  tableRowData!:any;
  scrollBarHidden: boolean = false;
  drillDownObj: any;
  scrollheight:number = 0;
/*   @Input('base-urls')
  set _base_urls(baseUrls: string){
    try{
      this.baseURLs = safeJsonInput<any>(baseUrls, null, 'detail-diag-view.parse1');
    }catch(e){
      console.log('Input not stable yet');
    }
  } */
  show = false;
  show_resolution = false;
  readonly detailDiagModalId = 'show-deatil-diag';

  showMore(id: string, tableConfigData: any, tableData: any,baseUrls:any,selectedFilterParams:any,globalParams:any) {
    this.tableRowData = tableData;
    //this.baseURLs = baseUrls;
    this.gridLoading = true;
    this.diagData = {
      header: [],
      data: [],
      safeCopyArr: [],
      settings: { default_row_height: 38 }
    };
    this.filterOptions = [];
    this.colSearch = [];
    this.selectedFilterParams = selectedFilterParams;
    // Paint the title, description, and resolution before the grid request
    // returns. The table region keeps its own loader.
    this.cdr.detectChanges();

    let globalParamsObj:any;
    if(!_.isEmpty(globalParams)){
      globalParamsObj = globalParams;//safeJsonInput<any>(globalParams, null, 'detail-diag-view.parse2')
    }

    this.baseModalLargest.showModal(id);
    this.cdr.detectChanges();
    this.getDetailDiagData(tableConfigData,tableData,baseUrls,selectedFilterParams,globalParamsObj)
  }
  closeModalCustom(id: string = this.detailDiagModalId) {
    this.baseModalLargest.closeModal(id);
    this.afterModalClosed.emit();
  }
  handleModalClosed() {
    this.afterModalClosed.emit();
  }
  constructor(private summaryDiagService: SummaryDiagnosticService, public el: ElementRef,
    private render:Renderer2, private dataFilterService: DashboardFilterService,
    private cdr: ChangeDetectorRef) {

   }

  ngOnInit() {
  }
  
  private changeScrollBarStyling(): void {
    const cdkScrollerEles: HTMLCollectionOf<Element> = document.getElementsByTagName('cdk-virtual-scroll-viewport');
    if (cdkScrollerEles.length) {
      this.scrollBarHidden = ((cdkScrollerEles[0] as HTMLElement).scrollHeight > (cdkScrollerEles[0] as HTMLElement).offsetHeight) ? false : true;
    } else {
      this.scrollBarHidden = true;
    }
  }
  diagData:any ={
    header:[],
    data:[]
  };

  // Sequence stamp used to ignore stale async work (filter option builders)
  // when the user reopens the modal with a different diagnostic before the
  // previous deferred build has executed.
  private currentLoadSeq = 0;

  // Memoize filter option arrays keyed by DIAG_KEY + header signature + row
  // count so reopening the same diagnostic skips the O(rows*cols) rebuild.
  private filterOptionsCache: Map<string, any[]> = new Map();

  getDetailDiagData(tableConfigData:any,tableData:any,baseURLs:any,selectedFilterParams:any,globalParams:any){
    if(_.isEmpty(selectedFilterParams)){
      let params:any = {};
      params['tax_year']= tableData.TAX_YEAR;
      params['scenario'] = tableData.SCENARIO;
      params['system']= 'A';
      params['filing_key'] = 1;
     let me:any={}
      me = _.find(this.dataFilterService.screenFilters,(i:any)=>{
              if(i.screen_key == globalParams.screen_key){
                return i.selectedBusiness;
              }
            });
     params['parent_me_string'] = _.map(me['selectedBusiness'],'VALUE').join(',');
     selectedFilterParams = params;
     this.selectedFilterParams = selectedFilterParams;
    }

    const seq = ++this.currentLoadSeq;
    this.summaryDiagService
      .getDiagData(tableConfigData, baseURLs.api, tableData, selectedFilterParams, globalParams).pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        (data: any) => this.handleDiagDataSuccess(data, tableData, seq),
        (error: any) => this.handleDiagDataError(error, seq)
      );
  }

  private handleDiagDataSuccess(rawData: any, tableData: any, seq: number): void {
    if (seq !== this.currentLoadSeq) {
      // Stale response — never let the spinner stay stuck. We still
      // flip the loader off so older requests that completed after a
      // newer one was fired do not leave the UI loading forever.
      this.gridLoading = false;
      this.cdr.detectChanges();
      return;
    }
    try {
      const normalized = this.normalizeDiagResponse(rawData);
      this.transformHeaders(normalized.header, tableData);
      this.scrollheight = this.computeScrollHeight();

      // First-paint assignment — give the table everything it needs to render
      // before doing any extra work.
      this.diagData.header = normalized.header;
      this.diagData.settings = normalized.settings;
      this.diagData.safeCopyArr = normalized.data.slice();
      this.diagData.data = normalized.data;
      this.visibleColumnCount = this.getVisibleColumnCount(normalized.header);

      // Use cached filter options when available so reopening the same
      // diagnostic does not re-walk the rows.
      const cacheKey = this.makeFilterCacheKey(normalized.header, normalized.data, tableData);
      const cached = cacheKey ? this.filterOptionsCache.get(cacheKey) : undefined;
      if (cached) {
        this.filterOptions = cached;
      } else {
        this.filterOptions = [];
        this.scheduleFilterOptionsBuild(normalized.header, normalized.data, cacheKey, seq);
      }
    } catch (error) {
      console.error('detail diagnostic response processing failed', error);
      this.diagData.data = [];
      this.diagData.safeCopyArr = [];
    } finally {
      // Always hide the spinner once the success callback runs, and force
      // change detection so the modal updates even if the callback fired
      // outside Angular's normal CD cycle.
      this.gridLoading = false;
      this.cdr.detectChanges();
    }
  }

  private handleDiagDataError(error: any, seq: number): void {
    if (seq !== this.currentLoadSeq) {
      this.gridLoading = false;
      this.cdr.detectChanges();
      return;
    }
    console.error('detail diagnostic load failed', error);
    this.diagData = {
      header: [],
      data: [],
      safeCopyArr: [],
      settings: { default_row_height: 38 }
    };
    this.filterOptions = [];
    this.colSearch = [];
    this.gridLoading = false;
    this.cdr.detectChanges();
  }

  private normalizeDiagResponse(data: any): { header: any[]; data: any[]; settings: any } {
    // The backend may return the payload either directly as
    // { header, data, settings } or wrapped as { jsonObject: { ... } }
    // depending on the action_id. Unwrap defensively so both shapes work.
    let safe: any = data || {};
    if (safe.jsonObject !== undefined && safe.jsonObject !== null) {
      safe = safe.jsonObject;
    }
    if (!safe || typeof safe !== 'object') {
      safe = {};
    }
    return {
      header: Array.isArray(safe.header) ? safe.header : [],
      data: Array.isArray(safe.data) ? safe.data : [],
      settings: safe.settings || { default_row_height: 38 }
    };
  }

  private transformHeaders(header: any[], tableData: any): void {
    if (!header.length) {
      return;
    }
    const diagName = tableData?.DIAG_NAME;
    const uiAmtLabel = tableData?.UI_AMT_COLUMN_NAME;
    let diagIndex = -1;
    for (let i = 0; i < header.length; i++) {
      const key = header[i];
      if (diagName && key.map === diagName) {
        key.label = uiAmtLabel ? uiAmtLabel : key.label;
        key.display = 'y';
        diagIndex = i;
      }
      key.width = Number(key.width || 0) + 25;
    }
    if (diagName && diagIndex > -1 && header.length > 7) {
      this.swap(header, diagIndex, 7);
    }
  }

  private computeScrollHeight(): number {
    const FALLBACK = 300;
    const view = this.modalContentHeight?.nativeElement;
    if (!view) {
      return FALLBACK;
    }
    const inner = view.children?.[1];
    if (!inner) {
      return FALLBACK;
    }

    let aboveDivHeight = 0;
    const children = inner.children;
    for (let i = 0; i < children.length; i++) {
      const child = children[i];
      if (child.className === 'row') {
        aboveDivHeight += child.clientHeight;
      }
    }

    if (aboveDivHeight <= 0) {
      return FALLBACK;
    }

    const headerEl =
      this.el.nativeElement.querySelector('.ap-modal-header') ||
      document.querySelector('.ap-modal-header');
    const headerHeight = headerEl ? (headerEl as HTMLElement).clientHeight : 60;
    return view.offsetHeight - (aboveDivHeight + headerHeight + 150);
  }

  private scheduleFilterOptionsBuild(
    header: any[],
    rows: any[],
    cacheKey: string | null,
    seq: number
  ): void {
    // Defer to next macro task so the table can paint before we spend time
    // building filter options.
    setTimeout(() => {
      if (seq !== this.currentLoadSeq) {
        return;
      }
      const options = this.buildFilterOptions(header, rows);
      if (seq !== this.currentLoadSeq) {
        return;
      }
      this.filterOptions = options;
      if (cacheKey) {
        this.filterOptionsCache.set(cacheKey, options);
      }
      this.cdr.detectChanges();
    }, 0);
  }

  private makeFilterCacheKey(header: any[], rows: any[], tableData: any): string | null {
    if (!tableData?.DIAG_KEY) {
      return null;
    }
    let headerSig = '';
    for (let i = 0; i < header.length; i++) {
      const h = header[i];
      headerSig += h.map + ':' + (h.display || '') + '|';
    }
    return tableData.DIAG_KEY + '|' + rows.length + '|' + headerSig;
  }

  private getVisibleColumnCount(columns: any[] = []): number {
    let count = 0;
    for (let i = 0; i < columns.length; i++) {
      const col = columns[i];
      if (col.display == 'y' && col.map != 'object_id') {
        count++;
      }
    }
    return count || 1;
  }

  private buildFilterOptions(headers: any[] = [], rows: any[] = []): any[] {
    const visibleHeaders: any[] = [];
    for (let i = 0; i < headers.length; i++) {
      const col = headers[i];
      if (col.display == 'y' && col.map != 'object_id') {
        visibleHeaders.push(col);
      }
    }

    const colCount = visibleHeaders.length;
    if (colCount === 0) {
      return [];
    }

    const options: any[] = new Array(colCount);
    const keys: string[] = new Array(colCount);
    const seenSets: Set<any>[] = new Array(colCount);

    for (let c = 0; c < colCount; c++) {
      const col = visibleHeaders[c];
      keys[c] = col.map;
      seenSets[c] = new Set();
      options[c] = {
        key: col.map,
        width: col.width,
        values: [],
        dropdownValues: [],
        filterUserInput: ''
      };
    }

    for (let r = 0, rowCount = rows.length; r < rowCount; r++) {
      const row = rows[r];
      for (let c = 0; c < colCount; c++) {
        const col = visibleHeaders[c];
        const key = keys[c];
        const value = this.filterSourceValue(col, row);
        if (value !== undefined && value !== null && value !== '' && !seenSets[c].has(value)) {
          seenSets[c].add(value);
          // Appkit renders the option list itself, reading the checkbox and the
          // accessibility role off each item. The diagnostic column shows AMT
          // (or "Yes"), not row[map], so the option value has to be that same text.
          options[c].values.push({ key, value, showCheckbox: true, role: 'checkbox' });
        }
      }
    }

    for (let c = 0; c < colCount; c++) {
      options[c].dropdownValues = options[c].values.slice();
    }

    return options;
  }

  // The highlighted diagnostic column renders AMT (or "Yes" when AMT is empty).
  // Reading row[map] leaves that dropdown with no options even though the cells
  // have values. Every other column still filters on its own field.
  private filterSourceValue(col: any, row: any): any {
    if (!col || !row) {
      return undefined;
    }
    const isDiagAmountColumn = this.tableRowData?.DIAG_NAME
      && col.map === this.tableRowData.DIAG_NAME
      && col.drilldown != null
      && col.format === 'color-dot';
    if (!isDiagAmountColumn) {
      return row[col.map];
    }
    if (row.AMT != null && row.AMT !== '') {
      const num = Number(row.AMT);
      if (!Number.isNaN(num)) {
        return new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(num);
      }
      return String(row.AMT);
    }
    return 'Yes';
  }

  swap(data:any,from:any,to:any){
        var f = data.splice(from, 1)[0];
    // insert stored item into position `to`
        data.splice(to, 0, f);
        return data;
    }
  gridFilters :any = {
    gridFilters:[],
    drillDownRefresh:0,
    filterObj:{},
    screenFilter:[]
};
  checkCondition(obj:any,rowData:any){
      if (!obj?.rule) {
        return false;
      }
      if(obj.rule['operator']=='=' && obj.rule['value'] == rowData[obj.rule['map']]){
        return true;
      }
      else if(obj.rule['operator']=='!=' && obj.rule['value'] != rowData[obj.rule['map']]){
        return true;
      }
      return false;
  }
  redirectDrillDown(rowData: any, i: any) {
    // Mirror legacy `detailedDiagnosticController.js` `case 'drillDown'`:
    // resolve the column's drilldown rule, hydrate `screenFilter` + build a
    // local `gridFilters` array from the row, then bubble a payload whose
    // top level exposes `activity_key` / `screen_key` / `screenFilter` /
    // `gridFilters` (the AngularJS bridge in `GlobalControllers.js` reads
    // those four keys directly).
    //
    // IMPORTANT: legacy declares the `gridFilters` container *inside* each
    // handler call so a stale array from the previous click never leaks into
    // the next request. The earlier Angular implementation pushed into
    // `this.gridFilters.gridFilters` (a class-field instance), which caused
    // entries from one drilldown to accumulate on the next.
    let drillObject: any = this.diagData?.header?.[Number(i)];
    let drilldownConfig: any = rowData?.DRILLDOWN;
    if (!drilldownConfig && drillObject?.drilldown) {
      drilldownConfig = drillObject.drilldown;
    }
    if (!drilldownConfig) {
      drillObject = _.find(this.diagData.header, { map: rowData.DIAG_NAME });
      drilldownConfig = drillObject?.drilldown;
    }
    if (!drilldownConfig) {
      drillObject = _.find(this.diagData.header, (h: any) => h.drilldown != null);
      drilldownConfig = drillObject?.drilldown;
    }
    if (!drilldownConfig) {
      return;
    }

    const drillDownRuleObj = safeJsonInput<any>(drilldownConfig, null, 'detail-diag-view.parse3');
    let obj: any;
    if (_.isArray(drillDownRuleObj)) {
      _.each(drillDownRuleObj, (rule: any) => {
        if (this.checkCondition(rule, rowData)) {
          obj = rule.drillDown;
        }
      });
    } else {
      obj = drillDownRuleObj;
    }
    if (!obj) {
      return;
    }
    obj = _.cloneDeep(obj);
    const drillDownRefresh = Number(
      drillObject?.drilldown_filter_refresh ?? obj.drillDownRefresh ?? obj.drilldown_filter_refresh ?? 0
    ) === 1 ? 1 : 0;

    _.each(obj.screenFilter, (sf: any) => {
      if (sf?.name) {
        const key = sf.row_data_key;
        const valueFromRow = key ? rowData?.[key] : undefined;
        const valueFromSummary = key ? this.tableRowData?.[key] : undefined;
        const valueFromParams = this.selectedFilterParams?.[sf.name];
        const fallbackKey = key ? String(key).toLowerCase() : '';
        const valueFromParamsByKey = fallbackKey ? this.selectedFilterParams?.[fallbackKey] : undefined;
        const nextValue = valueFromRow ?? valueFromSummary ?? valueFromParams ?? valueFromParamsByKey;

        if (nextValue !== undefined && nextValue !== null && String(nextValue).length > 0) {
          sf.value = key == 'TAX_YEAR' ? String(nextValue) : nextValue;
        }
      }
    });

    const gridFilterEntries: any[] = [];
    if (obj.filters && obj.filters.length) {
      _.each(obj.filters, (key: any) => {
        const v: any = rowData[key];
        if (v && (v.length || _.isNumber(v))) {
          gridFilterEntries.push({
            predicate: key,
            value: [v],
            type: 'array',
            reverse: false,
            operator: '[]',
          });
        }
      });
    }
    obj.gridFilters = gridFilterEntries;

    const payload: any = {
      ...obj,
      gridFilters: gridFilterEntries,
      drillDownRefresh,
      filterParams: this.selectedFilterParams,
      forceFilterReload: true,
    };

    this.drillDownObj = obj;
    this.gridFilters = payload;
    this.summaryDiagService.drillDown.isDrillDown = true;
    this.summaryDiagService.drillDown.selectedFilterParms = this.selectedFilterParams;

    this.loadDrillDownScreen.emit(payload);

    // Defer the modal close to the next macrotask so the AngularJS bridge
    // (`load-detail-dashboard` -> `workspaceFactory.loadLink` -> `$state.go`)
    // has time to fire its UI-Router transition BEFORE this component's
    // host tree starts being torn down by `showAddEditModalViewer = false`.
    // Without this delay, the synchronous teardown of `gtw-detail-diag-view`
    // collides with the in-flight `$rootScope.$digest` started by `$state.go`,
    // which aborts the transition silently — the bridge log appears but the
    // browser never navigates. Appkit4's modal is portaled to <body>, so it
    // remains visible until we explicitly call `closeModalCustom()`; queuing
    // that call lets UI-Router finish the screen swap underneath, then the
    // overlay disappears revealing the new screen.
    setTimeout(() => {
      try {
        this.closeModalCustom();
      } catch (e) {
        // Ignore close errors - navigation has already been requested.
      }
    }, 0);
  }
  filterOptions:any =[];

  get visibleDiagColumns(): any[] {
    return (this.diagData?.header || []).filter((col: any) => col.display === 'y' && col.map !== 'object_id');
  }

  get diagDisplayedColumns(): string[] {
    return this.visibleDiagColumns.map((col: any) => col.map);
  }

  getFilterOption(key: string): any {
    return this.filterOptions.find((opt: any) => opt.key === key);
  }

  getFilterOptionIndex(key: string): number {
    return this.filterOptions.findIndex((opt: any) => opt.key === key);
  }

  createFilterOptions(col:any){
    let filterArray:any = [];
    let  obj:any = {};
      _.each(this.diagData.data,(i:any)=>{
          if(i[col.map] && col.map != 'object_id'){
            if(filterArray.length == 0 || _.filter(filterArray,{value:i[col.map]}).length==0){
              filterArray.push({'key':col.map,'value':i[col.map],'showCheckbox':true,'role':'checkbox'} );
          }
        }
      });
      if(this.filterOptions && (this.filterOptions.length==0 || _.filter(this.filterOptions,{key:col.map}).length == 0)){
        let obj:any = {};
          obj['selected_'+col.map] = [];
          obj['key'] = col.map;
          obj['values']= filterArray;
          obj['dropdownValues']= filterArray.slice();
          obj['width']= col.width;
          obj['filterUserInput'] = '';
        this.filterOptions.push(obj);

      }
  }
  headerFilteroptions:any;
  colSearch:any = [];
  filterMultiSelectCol(selected:any,col:any,index:any){
      let filtered:any=[];
      filtered = _.cloneDeep(this.diagData.safeCopyArr);
      const multiSelects = this.mutlSelect.toArray();
      if(multiSelects[index]?.showList){
        setTimeout(()=>{
          multiSelects[index].hide();
        },10)
      }
      // Every option in a column carries that column's key, so `col.key` is the
      // predicate the removed PrimeNG-only `itemValue` used to supply.
      if(selected && selected.length>0){
        if(this.colSearch && (this.colSearch.length==0 || _.filter(this.colSearch,(ii:any)=> {return ii.predicate == col.key}).length ==0)){
          let obj:any = {};
          obj['predicate'] = col.key;
          obj['value'] = [];
          _.each(selected,(o:any)=>{
            obj.value.push(o.value);
          })
          this.colSearch.push(obj);
        }else{
          _.each(this.colSearch,(ii:any)=>{
            if(ii.predicate == col.key){
              ii.value = [];
              _.each(selected,(kk:any)=>{
                ii.value.push(kk.value)
              })
            }
          })
        }
      }else{
          this.colSearch = _.filter(this.colSearch,(kk:any)=>{ return kk.predicate != col.key});
      }
      if(this.colSearch && this.colSearch.length>0){
        _.each(this.colSearch,(kk:any)=>{
          filtered = this.findByValues(filtered, kk.predicate,kk.value)
        });
      }
      
        this.diagData.data = filtered;         
        /* _.each(this.filterOptions,(ii)=>{         

          //if((ii.key != this.colSearch[0]['predicate']) || ii.key != undefined ){
          if(((this.colSearch && this.colSearch.length>0)&& (ii.key != this.colSearch[0]['predicate']))){
            let filterArray:any = [];
            _.each(this.diagData.data,(row)=>{
              if(_.filter(filterArray,{value:row[ii.key]}).length==0){
                filterArray.push({'key':ii.key,'value':row[ii.key]} );

              }
            })
            ii.values = filterArray;
          }
        })  */
  }

  getFilterOptionByID(event:any,col: any) {
   let filterArray:any = [];
    _.each(this.diagData.data,(i:any)=>{
          if(i[col.key]){
            if(filterArray.length == 0 || _.filter(filterArray,{value:i[col.key]}).length==0){
              filterArray.push({'key':col.key,'value':i[col.key]} );
          }
        }
      });
      return filterArray;
  }
  findByValues(collection:any, property:any, values:any){
      const col = _.find(this.diagData?.header, { map: property }) || { map: property };
      return _.filter(collection, (item: any) => {
        return _.includes(values, this.filterSourceValue(col, item));
      });
  }


  onModalClick(){
      if(this.isDropDownOpen){
        _.each(this.mutlSelect.toArray(),(i)=>{
          if(i.showList){
              i.hide();
          }
        })
      }
  }

  // Appkit's dropdown does not narrow its own list while searching; it emits the
  // matches and expects them to be bound back, so each column filter renders
  // from `dropdownValues` rather than straight off `values`.
  onDropdownFilterResult(col:any,event:any){
    col.dropdownValues = event?.result || [];
  }
  isDropDownOpen:boolean = true;
  openMultiDropDown(_index: any){
    this.isDropDownOpen = true;
  }

  onFilterControlClick(event: Event, index: any){
    event.stopPropagation();
    this.openMultiDropDown(index);
  }
}


